import {
  ContentSectionItem,
  PossibleContentSections,
} from '../../../dynamic-content-page/fragment-and-types';
import { extractGenericConfig } from '../../../dynamic-content-page/helper';
import { getSectionId } from '../table-of-contents';
import { possibleComponents } from './possible-components';

export const addTableOfContentsHeadlines = (
  content: PossibleContentSections[],
) => {
  let tableOfContentsCounter = 1;
  const sections: ContentSectionItem[] = content
    .map<ContentSectionItem>((contentSection) => {
      const config = extractGenericConfig(possibleComponents, contentSection);

      if (config && config.addTableOfContentsHeadline) {
        return config.addTableOfContentsHeadline(contentSection);
      }

      return contentSection;
    })
    .map((section) => ({
      ...section,
      id:
        section.heading &&
        getSectionId(`${section.heading}-${tableOfContentsCounter++}`),
    }));

  return sections;
};
